import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { MonitorSlaSelectEvent } from '../../events/monitor-sla-select-event';
import { MonitorSlaChangeEvent } from '../../events/monitor-sla-change-event';


@Component({
  selector: 'e5core-ui-monitor-sla',
  template: `<e5core-ui-monitor-sla-highcharts 
      [categorisation]="categorisation" 
      [statuses]="statuses" 
      [slaRange]="slaRange" 
      [slaInDays]="slaInDays"
      (categoryChange)="onCategoryChange($event)"
      (slaSelect)="onSlaSelect($event)">
    </e5core-ui-monitor-sla-highcharts>`
})
export class E5coreUiMonitorSlaComponent implements OnInit {

  @Input() categorisation : number[]
  @Input() statuses : number[]
  @Input() slaRange : number = 24
  @Input() slaInDays : boolean = false
  @Output() categoryChange = new EventEmitter<MonitorSlaChangeEvent>() ;
  @Output() slaSelect = new EventEmitter<MonitorSlaSelectEvent>() ;

  constructor() { }

  ngOnInit() {    
  }

  onCategoryChange($event:MonitorSlaChangeEvent) {
    this.categoryChange.emit($event) ;
  }

  onSlaSelect($event:MonitorSlaSelectEvent) {
    this.slaSelect.emit($event) ;
  }
}
